import React, { useEffect, useState } from 'react';
import { Card, MetricCard, Plate } from '../components/Card';
import api, { getSheets } from '../api';

export default function Sheets() {
  const [sheets, setSheets] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => { getSheets().then(setSheets).catch(() => {}); }, []);

  const loadDetail = async (id) => {
    setSelected(id);
    try {
      const r = await api.get(`/sheets/${id}`);
      setDetail(r.data);
    } catch {
      setDetail(null);
    }
  };

  return (
    <div>
      <div className="kp-hero">
        <Plate>Данные · таблицы</Plate>
        <h1>Google Sheets</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        <MetricCard title="Подключено таблиц" value={sheets.length} />
        <MetricCard title="Всего строк" value={sheets.reduce((s, sh) => s + sh.rows, 0)} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: 16 }}>
        <Card title="Таблицы">
          {sheets.map(sh => (
            <div key={sh.sheet_id} onClick={() => loadDetail(sh.sheet_id)}
              style={{
                padding: '12px', borderRadius: 8, cursor: 'pointer', marginBottom: 4,
                background: selected === sh.sheet_id ? 'rgba(0,167,220,0.15)' : 'var(--bg3)',
                border: selected === sh.sheet_id ? '1px solid var(--accent)' : '1px solid transparent',
              }}>
              <div style={{ fontWeight: 600, fontSize: 13 }}>{sh.sheet_name}</div>
              <div style={{ color: 'var(--text2)', fontSize: 12, marginTop: 2 }}>{sh.rows} строк</div>
              <div style={{ color: 'var(--text2)', fontSize: 11, marginTop: 2 }}>
                {sh.updated_at?.slice(0, 16).replace('T', ' ')}
              </div>
            </div>
          ))}
          {!sheets.length && <div style={{ color: 'var(--text2)', fontSize: 13 }}>Нет подключённых таблиц.<br/>Добавьте GOOGLE_SHEET_IDS в .env</div>}
        </Card>

        <Card title={selected ? `Данные: ${selected}` : 'Выберите таблицу'}>
          {detail?.data && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid var(--border)' }}>
                    {(detail.data[0] || []).map((h, i) => (
                      <th key={i} style={{ padding: '8px 12px', textAlign: 'left', color: 'var(--text2)', fontSize: 12, whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {detail.data.slice(1, 200).map((row, ri) => (
                    <tr key={ri} style={{ borderBottom: '1px solid var(--border)' }}>
                      {row.map((cell, ci) => (
                        <td key={ci} style={{ padding: '8px 12px', fontSize: 13, whiteSpace: 'nowrap' }}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {!selected && <div style={{ color: 'var(--text2)', padding: 20 }}>Выберите таблицу слева</div>}
        </Card>
      </div>
    </div>
  );
}
